import { mobileMessages } from '../../services/consts'
import FallbackViewer from './FallbackViewer'
import MobileViewer from './mobile/MobileViewer'

const messageRegister = {
  // TODO: add special cases by message name here
  // or it'll use the FallbackViewer and fallback.js to style
}

export function findComponent (n) {

  // mobile events need to be forwarded on
  if (mobileMessages.includes(n.message)) {
    return MobileViewer
  }

  // by message
  const byMessage = messageRegister[n.message] 
  if (byMessage) {
    return byMessage
  }

  // no idea, just use the fallback
  return FallbackViewer
}